import { render, staticRenderFns } from "./areaRotate1.vue?vue&type=template&id=b71dcc4a&"
import script from "./areaRotate1.vue?vue&type=script&lang=js&"
export * from "./areaRotate1.vue?vue&type=script&lang=js&"
import style0 from "./areaRotate1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports